// extracted by mini-css-extract-plugin
export default {"wrapper":"a2","dropdownButton":"b2","carat":"c2","caratPointingDown":"e2","selectBox":"f2","dropdown":"g2","header":"h2","instructions":"i2","counter":"j2","itemWrapper":"k2","flavorImg":"l2","left":"m2","quantityControl":"n2","quantity":"o2","qtyButton":"p2","minus":"q2","plus":"r2"};
    if(module.hot) {
      // 1738064243772
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  